export class Pagination {
  private readonly defaultValues: {page: number, perPage: number};

  page: number;
  perPage: number;
  total: number = 0;

  get pages() {
    if (this.total === 0 || this.total === null) {
      return 0;
    }
    return Math.ceil(this.total / this.perPage);
  }

  get hasPrev() {
    return this.page > 1;
  }

  get prevNum() {
    if (!this.hasPrev) {
      return null;
    }
    return this.page - 1;
  }

  get hasNext() {
    return this.page < this.pages;
  }

  get nextNum() {
    if (!this.hasNext) {
      return null;
    }
    return this.page + 1;
  }

  constructor(values: Partial<{page: number, perPage: number}> = {}) {
    const {page = 1, perPage = 50} = values;
    this.page = page;
    this.perPage = perPage;

    this.defaultValues = {page, perPage};
    Object.defineProperty(this, 'defaultValues', {
      enumerable: false,
    });
  }

  loadFromQuery(query: Record<string, any>) {
    this.page = parseInt(query.page, 10) || this.defaultValues.page;
    this.perPage = parseInt(query.perPage, 10) || this.defaultValues.perPage;
  }

  buildSearchParams(searchParams: URLSearchParams) {
    searchParams.append('page', String(this.page));
    searchParams.append('perPage', String(this.perPage));
    return searchParams;
  }
}
